module.exports = __webpack_public_path__ + "img/sounds.82d3bb1c.png";